import { CSSProperties, useCallback, useState } from 'react'

import { ContentCopy, OpenInNew } from '@mui/icons-material'
import { Button, Paper, Stack, Tooltip } from '@mui/material'

import { preview } from '@/components/form/preview'

import { copyToClipboard } from '@/utils'
import { useTexts } from '../useTexts'

const PaperStyle: CSSProperties = {
  background: '#F3F5F7',
  padding: '16px',
}

interface Props {
  link: string
}

const testidLink = 'trackingLink-link'
const testidCopyButton = 'trackingLink-copy-link'

export function TrackingLink(props: Props) {
  const { link } = props
  const texts = useTexts()

  const [status, setStatus] = useState<'ready' | 'copied'>('ready')

  const onCopyToClipboard = useCallback(async () => {
    const copied = await copyToClipboard(link)
    if (!copied) return
    setStatus('copied')

    setTimeout(() => {
      setStatus('ready')
    }, 2000)
  }, [link])

  const onOpenTrackingLink = useCallback(async () => {
    window.open(link, '_blank')
  }, [link])

  return (
    <>
      <Paper elevation={0} sx={PaperStyle}>
        <preview.Section>
          <preview.SectionTitle>{texts.sectionTitle}</preview.SectionTitle>
          <preview.Description>{texts.description}</preview.Description>
          <Stack spacing={2} direction="row">
            <Tooltip placement="top" title={texts.open}>
              <Button
                data-testid={testidLink}
                data-trackid={testidLink}
                onClick={onOpenTrackingLink}
                startIcon={<OpenInNew />}
                variant="contained"
              >
                {texts.trackingLinkLabel}
              </Button>
            </Tooltip>
            <Tooltip placement="top" title={status === 'ready' ? texts.copy : texts.copied}>
              <Button
                data-testid={testidCopyButton}
                data-trackid={testidCopyButton}
                onClick={onCopyToClipboard}
                startIcon={<ContentCopy />}
                variant="outlined"
              >
                {texts.copy}
              </Button>
            </Tooltip>
          </Stack>
        </preview.Section>
      </Paper>
    </>
  )
}
